import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateSurveyByAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveyUserSurvey/CreateSurvey");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateASurvey extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveyUserSurvey/UpdateSurvey");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetReportOfMasterSurveys extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveyUserSurvey/GetReportOfMasters");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetReportsOfSurveysByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveyUserSurvey/GetReportBymasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetReportsOfMasterByQuestionId extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveyUserSurvey/GetReportsOfMasterByQuestionIdSurvey");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateSurveyByAdmin,
  UpdateASurvey,
  GetReportOfMasterSurveys,
  GetReportsOfSurveysByMaster,
  GetReportsOfMasterByQuestionId,
};
